module.exports = __webpack_public_path__ + "img/hezuo.10467dc4.png";